import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=97f85d8e&scoped=true&"
import script from "./Dealers.vue?vue&type=script&lang=js&"
export * from "./Dealers.vue?vue&type=script&lang=js&"
import style0 from "./Dealers.vue?vue&type=style&index=0&id=97f85d8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f85d8e",
  null
  
)

export default component.exports